import {Component} from 'react';
import './UpdatePassword.css';

import Page from '@acri-tools/react-tools/components/Page/Page';
import { bannerImage } from '../../theme/images';
import { match } from 'react-router';
import UP from '@acri-tools/react-tools/components/_user_manager/UpdatePassword/UpdatePassword';

interface Props{
    match: match<{ token: string}>,
}


export default class UpdatePassword extends Component<Props>{
    render(){
        return (
        <Page 
            id="update-password"
            title="Update password"
            banner={{
                topBar: true,
                bannerImage: bannerImage
            }}
            footer
        >
            <div className="page-content">
                <div className="row-centered-column">
                    <div className="content-div"> 
                        <UP token={this.props.match?.params?.token}/>
                    </div>
                </div>
            </div>
        </Page>
        );
    }

};

